import { SelectedGame } from '../types/SwipeSDKConfigType';

export const setLocalStore = (
  key: string,
  value: boolean | SelectedGame,
): void => {
  try {
    const serializedValue = JSON.stringify(value);
    localStorage.setItem(key, serializedValue);
  } catch (error) {
    console.error('Error setting item in local storage:', error);
  }
};

export const getLocalStore = (key: string) => {
  try {
    const serializedValue = localStorage.getItem(key);
    if (serializedValue === null) {
      return null;
    }
    return JSON.parse(serializedValue);
  } catch (error) {
    console.error('Error getting item from local storage:', error);
    return null;
  }
};
